/**
 * Shared constants for map components
 */

import type { LatLngExpression } from 'leaflet';

/**
 * Place type icons mapping
 * Shared between passage-places and map-filters
 */
export const PLACE_TYPE_ICONS: Record<string, string> = {
    'city': '🏛️',
    'village': '🏘️',
    'region': '🗺️',
    'body-of-water': '🌊',
    'mountain': '⛰️',
    'valley': '🏞️',
    'desert': '🏜️',
    'oasis': '🌴',
    'route': '🛣️',
    'landmark': '🗿',
    'island': '🏝️',
    'encampment': '⛺'
};

/**
 * Default map center (Jerusalem)
 */
export const DEFAULT_MAP_CENTER: LatLngExpression = [31.7683, 35.2137];

/**
 * Map bounds padding for fitBounds
 */
export const MAP_BOUNDS_PADDING: [number, number] = [50, 50];

/**
 * Maximum zoom level for map
 */
export const MAP_MAX_ZOOM = 12;

/**
 * Delay before opening marker popup after animation (milliseconds)
 */
export const MARKER_POPUP_ANIMATION_DELAY = 600;

/**
 * Colors for coordinate confidence levels (scholarly consensus on identification)
 */
export const CONFIDENCE_COLORS: Record<string, string> = {
    'high': '#22c55e',      // Green - universally accepted
    'medium': '#eab308',    // Yellow - generally accepted with some debate
    'low': '#f97316',       // Orange - multiple proposed locations
    'disputed': '#ef4444'   // Red - active scholarly debate
};

